<template>
    <div>
        <el-row :gutter="20">

            <el-col :span="7">
                <img src="../assets/cover-blank.png" class="image" :style="{ 'background-image': 'url(' + item.cover + ')' }">
                <div class="price"><img src="../assets/rich.svg" style="height: 20px;"> {{ $n(item.price) }}</div>
            </el-col>
            <el-col :span="16">
                <h2 class="title">{{ item.name }}</h2>
                <div class="description">{{ item.description }}</div>

                <div class="info" v-if="parseInt(this.$store.getters.getUser.points) < parseInt(this.item.price)">
                    Заработайте больше баллов что бы заказать этот товар
                </div>

                <el-form :model="form" status-icon label-position="top" v-else>
                    <el-form-item :label="$t('phone')" prop="phone" :error="error_form.phone">
                        <el-input v-model="form.phone" placeholder="+1 123 456 8844"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('delivery_address')" prop="address" :error="error_form.address">
                        <el-input v-model="form.address" type="textarea" placeholder="Pushkina st., 12, ap. 11 Moscow, Russia, 125070"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="order" :loading="loading_form">{{ $t('order_gift_button') }}</el-button>
                        <el-button @click="cancel">{{ $t('cancel') }}</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "StoreOrder",
        props: {
            item: [Object]
        },
        data () {
            return {
                form: {
                    gift_id: this.item.id,
                    phone: this.$store.getters.getUser.phone,
                    address: this.$store.getters.getUser.address
                },
                error_form: {},
                loading_form: false
            }
        },
        watch:{
            'item'(){
                this.error_form = {};
                this.form.gift_id = this.item.id;
            },
        },
        methods: {
            order () {
                this.loading_form = true;
                this.$axios.post('/store/orders', this.form).then(() => {
                    this.error_form = {};
                    this.loading_form = false;
                    this.$store.dispatch('getUser');
                    this.cancel();
                    this.$emit('update')
                }).catch((error) => {
                    this.error_form = error.response.data;
                    this.loading_form=false;
                });


            },
            cancel () {
                this.$emit('cancel')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .image {
        max-width: 100%;
        width: 100%;
        display: block;
        background-size: cover;
        background-position: 50%

    }

    .price {
        margin-top: 10px;
        text-align: center;
        font-size: 18px;
        font-weight: bold;
    }

    .title {
        color: #6F7990;
    }

    .description {
        margin-bottom: 25px;
    }

    .info {
        text-align: center;
        font-size: 16px;
        color: #e6a23c;
    }

</style>